import React from 'react'
import { BannerInfo } from '../../../components/Banner/Banner.react'
import { useTranslation } from 'react-i18next'

export const NoChannelsBanner = () => {
  const { t } = useTranslation('settlements')
  return (
    <BannerInfo title='No Information Available' showIcon vertical>
      <div>{t('merchant-not-have-channels')}</div>
    </BannerInfo>
  )
}
